import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";
import { AuthService } from "./authService";

export class AlertService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
		this._authService = new AuthService();
	}

	streamMyActiveAlerts(isAlarmWall, callback) {
		const args = {
			filterType: "active-by-user",
			isAlarmWall: isAlarmWall
		};
		return this._rc.subscribe("ecosystem", "/alerts", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	getArchivedByPage(page, callback) {
		const url = `/ecosystem/api/alerts/archive/${page}`;
		this._restClient.exec_get(url, callback);
	}

	closeAlert(alertId, callback) {
		const url = `/ecosystem/api/alerts/${alertId}/close`;
		this._restClient.exec_put(url, null, callback);
	}

	closeBulkAlerts(ids, callback) {
		const body = JSON.stringify({
			ids
		});
		// cSpell:ignore closebulk
		const url = "/ecosystem/api/alerts/closebulk";
		this._restClient.exec_put(url, body, callback);
	}

	reopenAlert(alertId, callback) {
		const url = `/ecosystem/api/alerts/${alertId}/reopen`;
		this._restClient.exec_put(url, null, callback);
	}

	reopenBulkAlerts(ids, callback) {
		const body = JSON.stringify({
			ids
		});
		// cSpell:ignore reopenbulk
		const url = "/ecosystem/api/alerts/reopenbulk";
		this._restClient.exec_put(url, body, callback);
	}

	acknowledgeNotifications(alerts, callback) {
		// alerts: array of { alertId, occurrenceId } or legacy array of IDs
		const body =
			Array.isArray(alerts) && typeof alerts[0] === "string"
				? JSON.stringify(alerts.map(id => ({ alertId: id, occurrenceId: "*" })))
				: JSON.stringify(alerts);
		const url = "/ecosystem/api/alerts/acknowledge";
		this._restClient.exec_put(url, body, callback);
	}

	unAcknowledgeNotifications(alerts, callback) {
		// alerts: array of { alertId, occurrenceId } or legacy array of IDs
		const body =
			Array.isArray(alerts) && typeof alerts[0] === "string"
				? JSON.stringify(alerts.map(id => ({ alertId: id, occurrenceId: "*" })))
				: JSON.stringify(alerts);
		const url = "/ecosystem/api/alerts/un_acknowledge";
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * @param params
	 */

	getAlertsByContextAndRange(params, callback) {
		const { entityType, startDateTime, endDateTime, entityId } = params;
		const url = `/ecosystem/api/alerts/byContext/${entityType}/${entityId}?from=${startDateTime}&to=${endDateTime}`;
		this._restClient.exec_get(url, callback);
	}
	requestConcurrence(alertId, callback) {
		const url = `/ecosystem/api/alerts/${alertId}/concurrence/request`;
		this._restClient.exec_post(url, null, callback);
	}

	getAlertSummaryCodes(callback) {
		const url = "/ecosystem/api/alertSummaryCodes";
		this._restClient.exec_get(url, callback);
	}
	setAlertSummaryCodes(alertId, summaryPayload, callback) {
		const url = `/ecosystem/api/alerts/${alertId}/summary`;
		const body = JSON.stringify(summaryPayload);
		this._restClient.exec_put(url, body, callback);
	}
	respondToConcurrence(alertId, payload, callback) {
		const url = `/ecosystem/api/alerts/${alertId}/concurrence/respond`;
		const body = JSON.stringify(payload);
		this._restClient.exec_post(url, body, callback);
	}
	canUserProvideConcurrence(alertId, callback) {
		const url = `/ecosystem/api/alerts/${alertId}/concurrence/canRespond`;
		this._restClient.exec_get(url, callback);
	}
}
